import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getMatrixData = store => store[NAME].matrixData;
export const getYearList = store => store[NAME].yearList;
export const getIssueList = store => store[NAME].issueList;